export const DAILY_LIMIT_TYPE_DAILY_AD_ACCOUNT_ONLY_COST = "DAILY_AD_ACCOUNT_ONLY_COST";
export const DAILY_LIMIT_TYPE_DAILY_AD_ACCOUNT_COST_AND_BUDGET = "DAILY_AD_ACCOUNT_COST_AND_BUDGET";
export const DAILY_LIMIT_TYPE_DAILY_CAMPAIGN_ONLY_BUDGET = "DAILY_LIMIT_TYPE_DAILY_CAMPAIGN_ONLY_BUDGET";

export const DAILY_LIMIT_TYPE_DATA = {
    [DAILY_LIMIT_TYPE_DAILY_AD_ACCOUNT_ONLY_COST]: {
        "Spanish": "Aplica sobre el consumo total de la cuenta", 
        "SpanishShort": "Cuenta",
        "English": "Applies to total account consumption",
        "EnglishShort": "Account"
    },
    [DAILY_LIMIT_TYPE_DAILY_AD_ACCOUNT_COST_AND_BUDGET]: {
        "Spanish": "Aplica sobre presupuesto y consumo total de la cuenta", 
        "SpanishShort": "Cuenta",
        "English": "Applies to budget and total account consumption",
        "EnglishShort": "Account"
    },
    [DAILY_LIMIT_TYPE_DAILY_CAMPAIGN_ONLY_BUDGET]: {
        "Spanish": "Presupuesto configurado en Campaña", 
        "SpanishShort": "Campaña",
        "English": "Budget configured in Campaign",
        "EnglishShort": "Campaign"
    },
};

// Utility function to get localized text based on current language
export const getLocalizedText = (data, language = 'es', key = 'Spanish') => {
    if (!data) return '';
    
    // Map language codes to dictionary keys
    const languageMap = {
        'es': 'Spanish',
        'en': 'English'
    };
    
    const languageKey = languageMap[language] || 'Spanish';
    return data[languageKey] || data['Spanish'] || '';
};

// Utility function to get localized short text
export const getLocalizedShortText = (data, language = 'es') => {
    if (!data) return '';
    
    const languageMap = {
        'es': 'SpanishShort',
        'en': 'EnglishShort'
    };
    
    const languageKey = languageMap[language] || 'SpanishShort';
    return data[languageKey] || data['SpanishShort'] || '';
};

/*
Usage Example in a React component:

import { DAILY_LIMIT_TYPE_DATA, getLocalizedText, getLocalizedShortText } from '../daily_limits';
import { withTranslation } from 'react-i18next';

class MyComponent extends Component {
    render() {
        const { i18n } = this.props;
        const limitType = 'DAILY_AD_ACCOUNT_ONLY_COST';
        
        // Get full description
        const fullText = getLocalizedText(DAILY_LIMIT_TYPE_DATA[limitType], i18n.language);
        
        // Get short description
        const shortText = getLocalizedShortText(DAILY_LIMIT_TYPE_DATA[limitType], i18n.language);
        
        return (
            <div>
                <p>{fullText}</p>
                <span>{shortText}</span>
            </div>
        );
    }
}

export default withTranslation()(MyComponent);
*/
